export default {"src":"/_next/static/media/arrow-up.96460e5a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};